import type { CellContentType, CellPaddingVariant } from './types';

export const BORDER_WIDTH = 1;
/** Special column key for bulk selection checkbox. Injected when any column has bulkEdit. */
export const BULK_SELECT_COLUMN_KEY = '__bulkSelect';
export const HEADER_HEIGHT = 48;
export const CELL_HEIGHT = 64;
/** Cell horizontal padding in px (left and right). Used by Row and Header. */
export const CELL_PADDING = 24;
/** Compact cell padding (e.g. checkbox right, action left, expand/collapse right). */
export const CELL_PADDING_COMPACT = 12;

/** Returns paddingLeft and paddingRight in px for the given variant. */
export function getCellPadding(variant: CellPaddingVariant = 'default'): { paddingLeft: number; paddingRight: number } {
  if (variant === 'compactRight') {
    return { paddingLeft: CELL_PADDING, paddingRight: CELL_PADDING_COMPACT };
  }
  if (variant === 'compactLeft') {
    return { paddingLeft: CELL_PADDING_COMPACT, paddingRight: CELL_PADDING };
  }
  if (variant === 'noLeft') {
    return { paddingLeft: 0, paddingRight: CELL_PADDING };
  }
  return { paddingLeft: CELL_PADDING, paddingRight: CELL_PADDING };
}

/**
 * Default padding variant for a cell content type. Use when column.paddingVariant is not set.
 * Summary of padding per content type breakdown: action → compactLeft; check, expandCollapse → compactRight; text, avatarText, summary, facePile, status, tag, toggle → default.
 */
export function getDefaultPaddingVariantForContentType(contentType: CellContentType | undefined): CellPaddingVariant {
  if (contentType === 'action') {
    return 'compactLeft';
  }
  if (contentType === 'check' || contentType === 'expandCollapse') {
    return 'compactRight';
  }
  return 'default';
}
/** Action column header: ellipsis-h icon with 20px left, 36px right padding. */
export const ACTION_HEADER_PADDING_LEFT = 20;
export const ACTION_HEADER_PADDING_RIGHT = 36;

export const TABLE_CELL_FONT_SIZE = 'body-sm';
export const HEADER_CONTROL_SIZE = 'xxs';
export const HEADER_INPUT_SIZE = 'xs';
export const INACTIVE_SORT_FILTER_COLOR = 'gray-600';
export const ACTIVE_SORT_FILTER_COLOR = 'blue-500';

export const DATE_COLUMN_WIDTH = 120;
export const ISO_DATE_WIDTH = 200;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
